import { create } from "zustand"
import { getContactsBatch } from "../schemas/Chat"

export const useContactStore = create((set, get) => ({
    contactsById: {},
    contactsByIdentity: {},

    upsertContact: (contact) =>
        set((state) => {
            const newById = { ...state.contactsById }
            const newByIdentity = { ...state.contactsByIdentity }

            const merged = {
                ...newById[contact._id],
                ...contact
            }

            newById[contact._id] = merged

            // 🔥 indexar identities
            if (Array.isArray(merged.identities)) {
                for (const identity of merged.identities) {
                    if (!identity?.value) continue

                    newByIdentity[identity.value] = merged
                }
            }

            // 🔥 fallback telefone
            if (merged.number) {
                const phone = merged.number.replace(/\D/g, '')
                newByIdentity[phone] = merged
            }

            return {
                contactsById: newById,
                contactsByIdentity: newByIdentity
            }
        }),

    upsertManyContacts: (contacts) =>
        set((state) => {
            const newById = { ...state.contactsById }
            const newByIdentity = { ...state.contactsByIdentity }

            for (const id in contacts) {
                const c = contacts[id]

                newById[id] = {
                    ...newById[id],
                    ...c
                }

                if (Array.isArray(c.identities)) {
                    for (const identity of c.identities) {
                        if (!identity?.value) continue

                        newByIdentity[identity.value] = newById[id]
                    }
                }

                if (c.number) {
                    const phone = c.number.replace(/\D/g, '')
                    newByIdentity[phone] = newById[id]
                }
            }

            return {
                contactsById: newById,
                contactsByIdentity: newByIdentity
            }
        }),

    getContact: (id) => get().contactsById[id],
    getContactByIdentity: (value) => get().contactsByIdentity[value],
}))

const pendingBatch = new Set()
const inFlight = new Set()
let batchTimer = null

export async function fetchContactsBatch(ids = []) {
    if (!ids.length) return

    const filteredIds = ids.filter(id => !inFlight.has(id))

    if (!filteredIds.length) return

    filteredIds.forEach(id => inFlight.add(id))

    try {
        const contactsArray = await getContactsBatch(filteredIds)

        const contactsMap = {}

        contactsArray.forEach(c => {
            contactsMap[c._id] = c
        })

        const { upsertManyContacts } = useContactStore.getState()

        upsertManyContacts(contactsMap)
    } catch (err) {
        // opcional: log
    } finally {
        // libera os ids
        filteredIds.forEach(id => inFlight.delete(id))
    }
}

export function queueContactFetch(contact_id) {
    const { contactsById } = useContactStore.getState()

    if (contactsById[contact_id]) return

    if (inFlight.has(contact_id)) return

    pendingBatch.add(contact_id)

    if (batchTimer) return

    batchTimer = setTimeout(async () => {
        const ids = Array.from(pendingBatch)

        pendingBatch.clear()
        batchTimer = null

        await fetchContactsBatch(ids)
    }, 100)
}

export const useContact = (id) => useContactStore(state => state.contactsById[id])